/* Anavadhya — collection filters.
   Desktop: filter dropdowns in a toolbar; any change applies straight away.
   Mobile: the same form opens as a full-screen sheet and applies on "Show results".
   Without JS the form still works: it submits as a normal GET form. */
(function () {
  'use strict';

  var desktop = window.matchMedia('(min-width: 990px)');

  function init(form) {
    if (form.__anvReady) return;
    form.__anvReady = true;

    var section = form.closest('[data-anv-collection]') || document;
    var openBtn = section.querySelector('[data-anv-filters-open]');
    var closeBtns = section.querySelectorAll('[data-anv-filters-close]');
    var details = form.querySelectorAll('[data-anv-filter]');
    var lastFocus = null;

    // Leave empty fields out of the URL.
    form.addEventListener('submit', function () {
      form.querySelectorAll('input').forEach(function (input) {
        if ((input.type === 'number' || input.type === 'text') && input.value.trim() === '') input.disabled = true;
      });
    });

    // Desktop: apply as soon as something changes.
    form.addEventListener('change', function (event) {
      if (!desktop.matches) return;
      if (event.target.type === 'number') return; // price applies on Enter or when the panel closes
      submit();
    });
    form.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' && event.target.type === 'number') {
        event.preventDefault();
        submit();
      }
    });

    function submit() {
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
    }

    // Desktop: one dropdown open at a time; close on outside click or Escape.
    details.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!desktop.matches) return;
        if (d.open) {
          details.forEach(function (other) { if (other !== d) other.open = false; });
        } else if (d.querySelector('input[type="number"]')) {
          var changed = Array.prototype.some.call(d.querySelectorAll('input[type="number"]'), function (i) {
            return i.value !== i.defaultValue;
          });
          if (changed) submit();
        }
      });
    });
    document.addEventListener('click', function (event) {
      if (!desktop.matches) return;
      details.forEach(function (d) { if (d.open && !d.contains(event.target)) d.open = false; });
    });

    // Mobile sheet.
    function open() {
      lastFocus = document.activeElement;
      details.forEach(function (d) { d.open = true; });
      form.classList.add('is-open');
      document.documentElement.classList.add('anv-lock');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      var close = form.querySelector('[data-anv-filters-close]');
      if (close) close.focus();
    }
    function close() {
      if (!form.classList.contains('is-open')) return;
      form.classList.remove('is-open');
      document.documentElement.classList.remove('anv-lock');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    if (openBtn) openBtn.addEventListener('click', open);
    closeBtns.forEach(function (btn) { btn.addEventListener('click', close); });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (form.classList.contains('is-open')) { close(); return; }
      details.forEach(function (d) {
        if (d.open && desktop.matches) {
          d.open = false;
          var s = d.querySelector('summary');
          if (s) s.focus();
        }
      });
    });

    // Keep focus inside the open sheet.
    form.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab' || !form.classList.contains('is-open')) return;
      var items = form.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), summary');
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });

    // Switching to desktop width closes the sheet and the stacked panels.
    desktop.addEventListener('change', function (e) {
      if (e.matches) {
        close();
        details.forEach(function (d) { d.open = false; });
      }
    });
  }

  function start() {
    document.querySelectorAll('[data-anv-filters]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
